module.exports = __webpack_public_path__ + "media/images/icons/country_flags/rs-ddcb32f26689089a2a4279ee3960d84b.svg";